import { render, staticRenderFns } from "./CreatorsListItem.vue?vue&type=template&id=54fb29c2&scoped=true&"
import script from "./CreatorsListItem.vue?vue&type=script&lang=ts&"
export * from "./CreatorsListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorsListItem.vue?vue&type=style&index=0&id=54fb29c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fb29c2",
  null
  
)

export default component.exports